"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldRenderAddToCalendarButton = exports.getUseProviderInsuranceOnRegForm = exports.shouldHideSchedulingHelpMessages = exports.isDirectBookRenderedInDrawer = void 0;
const isDirectBookRenderedInDrawer = (config, featureFlags) => {
    return ((config === null || config === void 0 ? void 0 : config.render_type) === 'drawer' ||
        (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.dbw_render_in_drawer) === true);
};
exports.isDirectBookRenderedInDrawer = isDirectBookRenderedInDrawer;
const shouldHideSchedulingHelpMessages = (config) => {
    return (config === null || config === void 0 ? void 0 : config.enable_hide_scheduling_help_messages) === true;
};
exports.shouldHideSchedulingHelpMessages = shouldHideSchedulingHelpMessages;
const getUseProviderInsuranceOnRegForm = (config) => {
    return (config === null || config === void 0 ? void 0 : config.use_provider_insurance_on_reg_form) === true;
};
exports.getUseProviderInsuranceOnRegForm = getUseProviderInsuranceOnRegForm;
/**
 * Condition to render add to calendar button
 *
 * @param {object} visibility Visibility object
 * @param {string} visibility.role Role of the user
 * @returns
 */
const shouldRenderAddToCalendarButton = ({ role }) => {
    return role === 'consumer';
};
exports.shouldRenderAddToCalendarButton = shouldRenderAddToCalendarButton;
//# sourceMappingURL=configUtils.js.map